import { render, staticRenderFns } from "./EditDatabase.vue?vue&type=template&id=289f35a2&"
import script from "./EditDatabase.vue?vue&type=script&lang=js&"
export * from "./EditDatabase.vue?vue&type=script&lang=js&"
import style0 from "./EditDatabase.vue?vue&type=style&index=0&id=289f35a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports